import React, { createContext, useContext, useEffect, useState } from 'react'
import { ApiServiceContext, routes } from '../utils/shared.module'
import { ToastContext } from '../utils/shared.module'
import { useLocation, useNavigate } from 'react-router-dom'

import {
  SpecialCharacters,
  end_points,
  lowerCase,
  upperCase,
} from '../services/core.index'
import * as yup from 'yup'
import {
  logout,
  setCompanyDetails,
  setLoginToken,
  setRemember,
  setSystemSettings,
  setUserDetails,
} from '../store/loginSlice'
import { useDispatch, useSelector } from 'react-redux'
import { RootReduxProps } from '../store/reduxInterface'
import Login from '../pages/authentication/login/Login'
import { SUCCESS, TOCKEN_EXPIRED } from '../utils/constant/httpCodes'
import { setAppTitle, setProfileDetails } from '../store/commonSlice'
import {
  setisSuperAdmin,
  setroleinfo,
  setrolesPermissions,
} from '../store/rolesPermissions'
import { convertPlainobj } from '../utils/methods'

const loginFormSchema = yup.object({
  userName: yup.string().required('User Name address is required').trim(),
  password: yup.string().required('Password address is required').trim(),
})

export const LoginContext = createContext({
  submitLoginForm: (data: any) => {},
  loginFormSchema: loginFormSchema,
  changeRememberMe: (value: boolean) => {},
  rememberData: {},
  errorMessage: '',
  setdeviceInfo: (data: any) => {},
  loading: false,
})

const LoginComponentController = (props: any) => {
  const { postData } = useContext(ApiServiceContext)
  const { showSuccess } = useContext(ToastContext)
  const [errorMessage, setErrorMessage] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const [deviceInfo, setdeviceInfo] = useState({})
  const { rememberData } = useSelector((state: RootReduxProps) => state.login)

  const dispatch = useDispatch()
  const navigate = useNavigate()


  const submitLoginForm = async (data: any) => {
    const notifyToken = localStorage.getItem('clientToken')
    const payload: any = {
      ...data,
      ...deviceInfo,
      token: notifyToken,
      device_id: '123456',
    }
    setErrorMessage('')
    setLoading(true)
    try {
      const response = await postData(end_points.login.url, payload)
      setLoading(false)
      navigate('/admin-dashboard')
      // if (response.status === SUCCESS) {
      //   const result = response.data
      //   const { token, companyDetails, userDetails, systemSettings } = result

      //   if (token && userDetails && Object.keys(userDetails)) {
      //     dispatch(setLoginToken(token))
      //     dispatch(setUserDetails(userDetails))
      //     dispatch(setProfileDetails(userDetails))
      //     if (payload?.rememberMe === true) {
      //       dispatch(setRemember({ ...data }))
      //     } else {
      //       dispatch(setRemember({}))
      //     }

      //     if (userDetails.two_factor_authentication) {
      //       window.location.href = routes.twofa.path
      //     } else {
      //       const role_obj = result?.roleAndPermissionDetails || {}
      //       const isAdmin = result?.isSuperAdmin
      //       const permData = convertPlainobj(role_obj)
      //       dispatch(setSystemSettings(systemSettings))
      //       dispatch(setCompanyDetails(companyDetails))
      //       if (permData) dispatch(setroleinfo(permData))
      //       if (role_obj) dispatch(setrolesPermissions(role_obj))
      //       if (isAdmin)
      //         dispatch(setisSuperAdmin(isAdmin == 'no' ? false : true))
      //       window.location.href = routes.adminDashboard.path
      //     }
      //     // navigate("/dashboard");
      //   } else {
      //     setErrorMessage('Login details not provided')
      //   }
      // } else if (response.status === TOCKEN_EXPIRED) {
      //   dispatch(logout())
      // } else {
      //   setErrorMessage(response.data.message)
      // }
      return response
    } catch (error: any) {
      // setErrorMessage('Unable to proceed login')
      setErrorMessage(`${error.message}`)
    }
  }

  const changeRememberMe = (value: boolean) => {
    if (rememberData && !value) dispatch(setRemember({}))
  }

  useEffect(() => {
    dispatch(setAppTitle('Login'))
  })

  useEffect(() => {}, [errorMessage])

  return (
    <LoginContext.Provider
      value={{
        submitLoginForm,
        loginFormSchema,
        changeRememberMe,
        rememberData,
        errorMessage,
        setdeviceInfo,
        loading,
      }}
    >
      {props.children}
    </LoginContext.Provider>
  )
}

const LoginComponent = () => {
  return (
    <>
      <LoginComponentController>
        <Login />
      </LoginComponentController>
    </>
  )
}
export default LoginComponent
